module.exports = __webpack_public_path__ + "static/media/benefits-img-3.e8e27000.png";